import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import api from '@board/api'
import * as dateutil from '@/util/date-helper'
import fileViewer from '@appbase/util/doc-viewer-helper'
import ProgressRing from '@/components/common/ProgressRing.vue'

@Component({
    components: {
        ProgressRing,
    },
})
export default class AttachModal extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Boolean, default: false }) show!: boolean
    @Prop({ type: String }) fileCode!: string;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    fileList: article.FileStore[] = []

    isLoading: boolean = true;
    loadingMessage: string = 'Decryption is in progress.';
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    loadFile() {
        api.article.getArticleFile(this.fileCode).then((res: any) => {
            console.log(res)
            this.fileList = res
        })
    }

    close() {
        this.$emit('close');
    }

     // selectFile -> preview로 변경 2024.01.15
    preview(file: any) {
        if(this.CheckDocumentExtension(file.extension))//ms office문서만체크
        {
            if(file.exportStatus == 'Y'){
                fileViewer.open(file.name, file.exportUrl, false)
                this.$emit('close');
            }else{
                this.isLoading = false;
                api.article.createExportFile(file.id).then(res => {
                    var intervalCount = 10;
                    var trigger = setInterval(() => {
                        api.article.getArticleFile(this.fileCode).then((res: any) => {
                            intervalCount--;
                            if (res && res.length) {
                                this.fileList = res.map((file: any) => <any>{
                                    ...file,
                                    custom: true,
                                    uniqueIdentifier: file.id,
                                    type: 'Database'
                                }) as any;                                    

                                var decodeFile = this.fileList.filter((x) => x.id == file.id);    

                                if (decodeFile && decodeFile.length && decodeFile[0].exportStatus == 'Y')
                                {
                                    this.isLoading = true;
                                    clearInterval(trigger);
                                    fileViewer.open(decodeFile[0].name, decodeFile[0].exportUrl, false)
                                    this.$emit('close');
                                }
                                else
                                {
                                    if (intervalCount <= 0) 
                                    {
                                        this.isLoading = true;
                                        clearInterval(trigger);
                                        fileViewer.open(decodeFile[0].name, decodeFile[0].downloadUrl, false)
                                        this.$emit('close');
                                    } 
                                }
                            } 
                            else 
                            {
                                if (intervalCount <= 0) 
                                {
                                    this.isLoading = true;
                                    clearInterval(trigger);
                                    fileViewer.open(file.name, file.downloadUrl, false)
                                    this.$emit('close');
                                } 
                            }
                            //console.log("intervalCount", intervalCount);
                            // if(res[0].exportStatus == 'Y'){
                            //     this.isLoading = true;
                            //     clearInterval(trigger);
                            //     fileViewer.open(res[0].name, res[0].exportUrl, false)
                            //     this.$emit('close');
                            // }
                            // else{
                            //     if (intervalCount <= 0) {
                            //         this.isLoading = true;
                            //         clearInterval(trigger);
                            //         fileViewer.open(res[0].name, res[0].downloadUrl, false)
                            //         this.$emit('close');
                            //     } 
                            // }
                        })
                    }, 2000)
                });
            }
        }
        else{
            fileViewer.open(file.name, file.downloadUrl, true)
            this.$emit('close');
        }
    }

    //다운로드 추가 2024.01.15
    download(url: string){
        let _osCheck = navigator.userAgent;
        if(_osCheck.includes('Mac')) {
            //팀즈 앱 으로 접속 한 경우 2024.02.27
            if(_osCheck.includes('Safari') || this.isTeams == true)
            {
                let _a = document.createElement('a');
                _a.target = '_blank';
                _a.href = url;
                document.body.appendChild(_a);
                _a.click();
            } else { //팀플러스 앱으로 접속 한 경우 2024.02.27 
                (window as any).dsmobileapp.web2app('link','download', {'url':url, 'filename': name})
            }
        }else{
            location.href = url;
        }
    }

    getDate(dateStr: string, format: string) {
        console.log(dateStr)
        return dateutil.uGetDateFormat(format, dateutil.IEDate(dateStr))
    }

    CheckDocumentExtension(extension: string){
        var fileExtension = extension.toUpperCase().replace('.', '');
        var value = false;
        if (fileExtension == "DOCX"
            || fileExtension == "PPTX"
            || fileExtension == "XLSX"
        ) {
            value = true;
        }

        return value;
    }

    created() {
        this.loadFile()
    }
}
